import React, { Component } from "react";

class VidaUniversitaria extends Component {
	render() {
		return (<>
			<section>
				<h2>Vida universitària</h2>

				<p>
					Arreplegats no només són castells. Dins la colla també es duen a terme diferents activitats en l'àmbit social que ajuden a fomentar l'amistat i la germanor entre els arreplegats i les arreplegades. N'hi ha que són activitats de cada dia, com el postassaig, però també se n'organitzen d'altres periòdicament. Aquí us n'expliquem algunes.
				</p>

				<h4>Sopar del novato</h4>

				<p>
					Aquest és un sopar on les persones que acaben d'entrar a la colla s'inicien dins el món casteller universitari. El sopar del novato és molt més que un sopar; hi ha proves, jocs, i sobretot molta festa! Es realitza cada any, generalment a finals d'octubre, quan ja tothom es coneix una mica, però abans d'encarar el tram de diades d'hivern.
				</p>

				<h4>Capdesetmanazu</h4>

				<p>
					A finals de novembre, qualsevol arreplegat que vulgui pot anar al Capdesetmanazu. Aquest cap de setmana es passa en una casa rural i es duen a terme jocs, gimcanes, activitats esportives, i festa. És una de les primeres accions socials que es fan cada any, on la cohesió entre els membres i la germanor dins la colla es fa notar i va en augment.
				</p>

				<h4>Perpinyà</h4>

				<p>
					Des de fa molts anys, poc després de tornar de les vacances de Nadal s'organitza el viatge a Perpinyà. Ens acullen els Castellers del Riberal, de la Catalunya Nord, amb qui tenim una molt bona relació i sempre ens tracten d'allò més bé. Es duen a terme actuacions castelleres i assajos, però també és un viatge per passar-ho bé i fer gresca. L'assaig que es fa amb Riberal acostuma a ser el més important de l'any, i s'hi fan i es valoren les proves més grosses de la història d'Arreplegats.
				</p>

				<p>
					És un cap de setmana on tots els arreplegats, actius i no actius, es troben per gaudir un cap de setmana en família tot explicant vivències viscudes dins d'Arreplegats.
				</p>

				<h4>Viatjazu</h4>

				<p>
					No cada any hi ha un viatjazu, però és una de les activitats més reclamades. S'escull una ciutat o zona del món, i s'hi viatja durant 4 o 5 dies. Ens donem a conèixer arreu del món, sovint amb una colla amfitriona que ens acull. Alguns dels viatges que s'han dut a terme han sigut a París, Praga, Mallorca, o Berlín.
				</p>

				<h4>Sopar de final de temporada</h4>

				<p>
					Aquest sopar, com bé diu el seu nom, es realitza al final de cada temporada. Es fa un sopar de retrobament entre tots, per recordar el que s'ha viscut aquell any, per desitjar-se un bon estiu, i per acomiadar-se dels que l'any vinent ja no podran participar activament en l'activitat castellera de la colla. Moltes vegades aquest sopar crea una bona enyorança que serveix per agafar forces i encarar amb molta il·lusió la nova temporada que començarà al setembre.
				</p>

				<h4>Jornades Arreplegades</h4>

				<p>
					Aquesta trobada és bastant similar al Capdesetmanazu. Durant un cap de setmana de juny es viatja a una casa de colònies, es creen debats per opinar obertament sobre diferents aspectes de la colla, sopars, retrobaments, i serveix per acabar-se d'acomiadar entre tots.
				</p>

				<h4>L'Arreplegator</h4>

				<p>
					Des del moment que es va crear la colla l'any 1995, els Arreplegats hem tingut una revista interna: l'Arreplegator. Es publica 3 cops l'any: per Aniversari, per Perpinyà, i per Diada. L'organitza una persona anònima de la colla que un recull de les cartes i escrits que realitzen els arreplegats i les arreplegades.
				</p>

				<p>
					Consta sempre d'un apartat institucional on presidència, cap de colla, i hereus i pubilles publiquen les seves cartes. També hi ha sempre les cartes dels novatos, que donen a conèixer a la resta de la colla les noves incorporacions d'aquell any.
				</p>
			</section>
		</>);
	}
}

export default VidaUniversitaria;
